module.exports = __webpack_public_path__ + "static/media/menuExclusion.2161f854.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/menuExclusion.svg
// module id = 179
// module chunks = 0